import { Record } from 'immutable';
export default class Alert extends Record({
  id: undefined,
  message: undefined,
  type: undefined,
  titleText: undefined
}) {}